import { Add, EmojiEvents, Link, Remove, Star } from "@mui/icons-material";
import { Avatar, CircularProgress, Container, Dialog, Divider, Grid, IconButton, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "moment/locale/ca";
import PageAdmin from "../../components/PageAdmin";
import Loading from "../../components/Loading";
import { Finals, Inscrits, Opcions } from "../../db/firebase";
import CustomButton from "../../components/CustomButton";
import { comparses } from "../../data/comparses";
import theme from "../../theme";
import { ReactComponent as Logo } from "../../assets/img/logo_patum_infantil.svg";
import ConfettiExplosion from "react-confetti-explosion";

export default function SorteigAdmin() {
	const [loadingI, errorI, inscrits, getInscrits, addInscrit, removeInscrit] = Inscrits();
	const [loadingO, errorO, opcions, getOpcions, editarOpcions] = Opcions();
	const [loadingF, errorF, finals, getFinals, addFinals, removeFinals, removeInscrits] = Finals();
	const [num, setNum] = useState();
	const classes = useStyles();
	const [finalsS, setFinals] = useState([]);
	const [compSel, setCompSel] = useState("tabal");
	const [loading, setLoading] = useState(false);
	const [confeti, setConfeti] = useState(false);

	useEffect(() => {
		getOpcions();
		getInscrits();
		getFinals();
	}, []);

	const generarNum = () => {
		setNum(Math.trunc(Math.random() * inscrits?.length + 1));
	};

	const sortejar = () => {
		const inscritsOrder = [...inscrits?.slice(num - 1, inscrits?.length), ...inscrits?.slice(0, num - 1)];
		let opcio = 0;

		let comparsesTemp = comparses?.map((c) => {
			return { id: c.id, llista: [] };
		});

		inscritsOrder?.map((ins) => (ins.agafat = false));

		while (opcio < 5) {
			// eslint-disable-next-line no-loop-func
			inscritsOrder.map((inscrit, index) => {
				const op = inscrit?.comparses[opcio];
				if (op) {
					let comp = comparsesTemp.filter((c) => c.id === op)[0];
					const max = opcions?.comparses[op]?.max;
					if (!inscrit.agafat) {
						if (comp.llista.length < max + 2) {
							comp.llista.push({
								id: inscrit.id ?? "",
								nom_nen: inscrit.nom_nen ?? "",
								cognoms_nen: inscrit.cognoms_nen ?? "",
								data_n_nen: inscrit.data_n_nen ?? "",
								anys: moment().diff(inscrit.data_n_nen, "years"),
								dni_nen: inscrit.dni_nen ?? "",
								nom: inscrit.nom ?? "",
								cognoms: inscrit.cognoms ?? "",
								dni: inscrit.dni ?? "",
								telefon: inscrit.telefon ?? "",
								email: inscrit.email ?? "",
								data_n: inscrit.data_n ?? "",
								nom_acompanyant: inscrit.nom_acompanyant ?? "",
								cognoms_acompanyant: inscrit.cognoms_acompanyant ?? "",
								alcada: inscrit.alcada ?? "",
								dni_acompanyant: inscrit.dni_acompanyant ?? "",
								data_n_acompanyant: inscrit.data_n_acompanyant ?? "",
								comparsa: comparses?.find((c) => c.id === comp.id).nom,
								suplent: comp.llista.length < max ? "" : "SUPLENT",
							});
							inscrit.agafat = true;
						}
					}
				}
			});
			opcio++;
		}
		setLoading(true);

		setTimeout(() => {
			addFinals(comparsesTemp);
			setFinals(comparsesTemp);
			setLoading(false);
			setConfeti(true);
			setTimeout(() => {
				setConfeti(false);
			}, 3000);
		}, 3000);
	};

	return (
		<PageAdmin title="Sorteig">
			<Loading loading={loadingI}>
				<Container style={{ paddingTop: 30 }}>
					<Box className={classes.bloc} mb={4}>
						<Typography textAlign={"center"}>Número inicial</Typography>
						<Box textAlign={"center"}>
							<Typography variant="h1">{num ?? "-"}</Typography>
						</Box>
						<TextField
							name="num"
							value={num}
							onChange={(val) => setNum(val.target.value)}
							fullWidth
							label="Número aleatori"
							InputLabelProps={{
								shrink: true,
							}}
							type="number"
						/>
						<Box py={2} />
						{/* <Box py={2}>
							<CustomButton light title={"Generar número"} onClick={generarNum} fullWidth />
						</Box> */}
						<CustomButton title={"Iniciar sorteig"} onClick={sortejar} fullWidth disabled={num <= 0} />
					</Box>

					{finals?.length > 0 ? (
						<Box className={classes.bloc} mb={10}>
							<Box className={classes.confeti}>
								{confeti && <ConfettiExplosion force={0.8} duration={3000} particleCount={250} width={1500} />}
							</Box>
							<Typography variant="h2" mb={5} mt={2}>
								Resultats sorteig
							</Typography>

							<Box mb={5}>
								<Grid spacing={3} container>
									{comparses?.map((com) => (
										<Grid item md={2} onClick={() => setCompSel(com.id)}>
											<Box className={com.id === compSel ? classes.compActiu : classes.compNoActiu}>
												<Box display={"flex"} justifyItems={"center"} alignItems={"center"}>
													<img src={com.png} alt={com.nom} style={{ width: 30, height: 30, marginRight: 5 }} />
													<Typography variant="body1" style={{ fontSize: 16 }} color={"white"}>
														{com?.nom}
													</Typography>
												</Box>
											</Box>
										</Grid>
									))}
								</Grid>
							</Box>
							{finals
								?.filter((c) => c.id === compSel)
								?.map((c) => {
									const Comparsa = comparses.find((co) => co?.id === c?.id);
									const Icon = Comparsa?.icon;

									return (
										<Box className={classes.inscrit} p={3}>
											<Box display={"flex"} justifyItems={"center"} mb={2}>
												<img src={Comparsa.png} alt={Comparsa.nom} style={{ width: 30, height: 30, marginRight: 5 }} />

												{/* {Icon && <Icon style={{ fill: "white", width: 30, height: 30, marginRight: 5 }} />} */}
												<Typography variant="h3" color={"white"}>
													{Comparsa?.nom}
												</Typography>
											</Box>
											<Divider sx={{ borderColor: "white", marginBottom: 2 }} />

											{c?.llista
												?.filter((i) => i.suplent !== "SUPLENT")
												?.map((participant) => (
													<Box display={"flex"} alignItems={"center"}>
														<Star sx={{ color: "white", marginLeft: 1 }} />
														<Typography color="white" ml={1} style={{ fontSize: 20 }}>
															{participant?.nom_nen} {participant?.cognoms_nen} {participant?.suplent}
														</Typography>
													</Box>
												))}
										</Box>
									);
								})}
						</Box>
					) : (
						<Box className={classes.bloc} mb={10}>
							<Grid container spacing={3}>
								{inscrits?.map((inscrit, index) => (
									<Grid item md={3}>
										<Box className={classes.inscrit}>
											<Typography color="white" style={{ fontSize: 14 }} pb={1}>
												{index + 1}- {inscrit?.nom_nen} {inscrit?.cognoms_nen}
											</Typography>

											<Box display={"flex"}>
												{inscrit?.comparses?.map((c) => {
													const Comparsa = comparses.find((co) => co.id === c);

													return (
														<Box mr={1}>
															<Tooltip title={Comparsa?.nom}>
																<img src={Comparsa.png} alt={Comparsa.nom} style={{ width: 30, height: 30 }} />
																{/* <Comparsa.icon style={{ fill: "white", width: 30, height: 30 }} /> */}
															</Tooltip>
														</Box>
													);
												})}
											</Box>
										</Box>
									</Grid>
								))}
							</Grid>
						</Box>
					)}
				</Container>
			</Loading>
			{loading && (
				<Dialog
					style={{ backdropFilter: "blur(10px) sepia(5%)" }}
					open={loading}
					PaperProps={{ sx: { borderRadius: "30px", backgroundColor: theme.palette.primary.main } }}
				>
					<Box className={classes.loading}>
						<Logo style={{ fill: theme.color.primary }} />

						<CircularProgress color="secondary" />
						<Typography variant="h3" mt={3} color="white" textAlign={"center"}>
							Preparant resultats...
						</Typography>
					</Box>
				</Dialog>
			)}
		</PageAdmin>
	);
}

const useStyles = makeStyles((theme) => ({
	bloc: {
		backgroundColor: "white",
		padding: 20,
		borderRadius: 10,
	},
	inscrit: {
		borderRadius: 10,
		backgroundColor: theme.palette.primary.main,
		padding: 10,
	},

	compActiu: {
		transition: "0.2s",
		borderRadius: 10,
		backgroundColor: theme.palette.primary.main,
		padding: 10,
		cursor: "pointer",
		"& .MuiTypography-root": {
			color: "white",
		},
	},

	compNoActiu: {
		transition: "0.2s",
		borderRadius: 10,
		backgroundColor: theme.palette.secondary.main,
		padding: 10,
		cursor: "pointer",
		"& .MuiTypography-root": {
			color: "black",
		},
	},
	loading: {
		padding: 50,
		textAlign: "center",
	},
	confeti: {
		justifyContent: "center",
		alignItems: "center",
		display: "flex",
	},
}));
